import { render, staticRenderFns } from "./Template4.vue?vue&type=template&id=a2d232f2&scoped=true&"
import script from "./Template4.vue?vue&type=script&lang=js&"
export * from "./Template4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d232f2",
  null
  
)

export default component.exports